import { VuexModule, Module, Mutation } from 'vuex-module-decorators';
import Store from '@/store/index';
import { CenterModel } from '@/models/center';

@Module({
  dynamic: true,
  store: Store,
  name: 'center',
  namespaced: true,
})
export default class Center extends VuexModule {
  cached: { [key: string]: CenterModel } = {};

  @Mutation
  flushCachedById(id: string) {
    const changed = { ...this.cached }
    delete changed[id];
    this.cached = changed;
  }

  @Mutation
  flushAll() {
    this.cached = {};
  }

  @Mutation
  cacheOne(item: CenterModel) {
    if (!item.$id) {
      throw new Error('only stored centers with an $id can be cached');
    }
    this.cached = {
      ...this.cached,
      [item.$id]: item,
    };
  }

  get items() {
    return this.cached;
  }
}
